var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicebgscreen1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2544,
    viewBox: "0 0 1440 2544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2476,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1591.99 2193.01C1590.35 2000.82 1433.23 1846.36 1241.04 1848.01C1048.85 1849.67 894.378 2006.8 896.013 2198.99C897.647 2391.18 1054.77 2545.64 1246.96 2543.99C1439.15 2542.33 1593.62 2385.2 1591.99 2193.01ZM1426.5 2192.4C1425.62 2088.95 1341.49 2005.81 1238.59 2006.7C1135.7 2007.58 1053 2092.16 1053.87 2195.6C1054.75 2299.05 1138.88 2382.19 1241.78 2381.3C1344.68 2380.42 1427.38 2295.84 1426.5 2192.4Z",
    fill: "#FF6000",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicebgscreen1);
export default __webpack_public_path__ + "static/media/servicebgscreen1.31781c3cd0be9ddd25c4fc43b8f28ef8.svg";
export { ForwardRef as ReactComponent };